import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
    selector: 'app-post-edit-dialog',
    templateUrl: 'post-editor.component.html',
    styleUrls: ['./post-editor.component.scss']
})
export class PostEditorComponent {

    currentInfo: {
        currentPost: string,
        currentLabelPos: string
    };

    @ViewChild('editorElement') editorElement: ElementRef;
    @ViewChild('sizeCalculationDiv') sizeCalculationDiv: ElementRef;

    constructor(
        private dialogRef: MatDialogRef<PostEditorComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        this.currentInfo = {
            currentPost: "",
            currentLabelPos: ""
        };
        this.postTypes.forEach(pt => {
            if (pt === data.postType) {
                this.currentInfo.currentPost = pt;
            }
        });
        this.labelPositions.forEach(lp => {
            if (lp === data.labelPosition) {
                this.currentInfo.currentLabelPos = lp;
            }
        });
    }

    postTypes: string[] = [
        "TP", "IN", "INS", "TT", "TTS", "QC", "QCS", "PK", "PKS", "C", "SC", "45", "45B",
        "B", "PKB", "E", "CST", "CE", "QCT", "CSB", "NSP"
    ];

    labelPositions: string[] = [
        "Center", "Above", "Left Side", "Right Side", "Below"
    ];

    async apply() {
        const result = {
            postType: this.currentInfo.currentPost,
            labelPosition: this.currentInfo.currentLabelPos
        };
        this.dialogRef.close(result);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/post-editor/post-editor.component.ts